import angular from 'angular';

class modalCgvImportComponent {
    /*@ngInject*/
    constructor($translate, CONF, logger, PrincipalSvc) {
        this.$translate = $translate;
        this.CONF = CONF;
        this.PrincipalSvc = PrincipalSvc;
        this.logger = logger;
    }

    $onInit() {
        this.document = {};
        this.document.applicationDate = new Date();
    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }

    importCgvPdf() {
        if (this.form.$valid) {
            this.PrincipalSvc.uploadCgvPdf(this.document, this.resolve.subEntityId).then(
                result => {
                    if (result.status === 400 && result.data) {
                        this.logger.error(result.data.message);
                    }else if((result.status === 500 && result.data) || result.status === 406){
                        this.logger.error("Le fichier importé n'est pas au format attendu")
                    }else {
                        this.modalInstance.close();
                        this.logger.success("CGV importé avec succès", result)
                    }
                }
            );
        }
    }

}

angular.module('app.principal').component('modalCgvImportComponent', {
    templateUrl: require('./modal-cgv-import.html'),
    controller: modalCgvImportComponent,
    bindings: {
        modalInstance: '<',
        resolve: '<',
    },
});
